var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToadd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0008 10L10.0008 15.0711C10.0008 15.6234 9.55304 16.0711 9.00076 16.0711V16.0711C8.44847 16.0711 8.00076 15.6234 8.00076 15.0711V10L2.92969 10C2.3774 10 1.92969 9.55228 1.92969 9V9C1.92969 8.44772 2.3774 8 2.92969 8L8.00076 8V2.92893C8.00076 2.37665 8.44847 1.92893 9.00076 1.92893V1.92893C9.55304 1.92893 10.0008 2.37665 10.0008 2.92893L10.0008 8L15.0718 8C15.6241 8 16.0718 8.44772 16.0718 9V9C16.0718 9.55228 15.6241 10 15.0718 10L10.0008 10Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToadd);
export default __webpack_public_path__ + "static/media/toadd.35b135255cdbfd51e3cb2d017d849977.svg";
export { ForwardRef as ReactComponent };